import React from "react";
import "../DeleteCommonDialog/DeleteCommonDialog.scss";
import DeleteDialogIcon from "../../assets/images/vactor/delete-dialog-icon.svg";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { LightButton, PrimaryButton } from "../AllButtons/AllButtons";
import { deleteConversation } from "../../Services/chatbox.service";
import { useAppDispatch } from "../../Store/store";
 
interface DeleteProp {
  converstationId?:  any;
  isDeleteOpen: boolean;
  onClose : () => void ;
  handleGetConversation ?: () => any ;
}
const DeleteCommonDialog : React.FC<DeleteProp> = ( {converstationId , isDeleteOpen , onClose , handleGetConversation}) => {
  const dispatch = useAppDispatch();
  const handleDeleteConversation = () => {
   dispatch(deleteConversation(converstationId)).unwrap().then((response) => {
    if (response.status === 200) {
      handleGetConversation?.() ;
     onClose();
    }
   }).finally(()=>{
     onClose()
   })
 
  }
 
 
  return (
    <>
      <Dialog
        className="sign-out-dialog"
        open={isDeleteOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          className="sign-out-dialog-title"
          id="alert-dialog-title"
        >
         Delete
        </DialogTitle>
        <DialogContent className="sign-out-dialog-body">
          <div className="sign-out-block">
            <div className="sign-out-img">
              <img src={DeleteDialogIcon} alt="" />
            </div>
            <div className="sign-out-label-title">
            Are you sure you want to delete this chat?
            </div>
          </div>
       
        </DialogContent>
        <DialogActions className="sign-out-dialog-footer">
            <PrimaryButton onClick = {handleDeleteConversation}> Delete </PrimaryButton>
            <LightButton onClick={onClose}> Cancel </LightButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
 
export default DeleteCommonDialog;